<template>
    <div>
        <Panel module="Financeiro" title="Autorização" :showSearch="true" :showButtons="false">
            <div slot="content-main">
                <div class="autorization-main-filter">
                    <FilterQuery :filters="filters" :value="stringFilterModel" @input="onFilterQueryChange" />
                    <TableTotalPerPage :totalRecords="totalRecords" />
                </div>

                <AutorizationTable
                    class="mt-4"
                    :items="items"
                    :totalRecords="totalRecords"
                    :loading="loading"
                    :currentPage="currentPage"
                    @reload="list"
                    @page-change="setPageAndReload"
                    @clear-search="clearSearchAndReload"
                    @set-search="setSearchAndReload"
                    @set-total-per-page="setTotalPerPageAndReload"
                />
            </div>
        </Panel>
    </div>
</template>

<script>
import Panel from "@/ui/layout/Panel";
import FilterQuery from "@/ui/shared/filter-builder/FilterQuery.vue";
import TableTotalPerPage from "@/ui/shared/TableTotalPerPage.vue";
import AutorizationTable from "./AutorizationTable.vue";
import AutorizationService from "../../services/autorization.service";

import { mapGetters, mapMutations } from "vuex";

export default {
    name: "AutorizationMain",
    components: {
        Panel,
        FilterQuery,
        TableTotalPerPage,
        AutorizationTable,
    },
    data() {
        return {
            items: [],
            totalRecords: 0,
            loading: false,
            search: "",
            filter: "contains",
            stringFilter: "",
            stringFilterModel: [],
            currentPage: 1,
            totalPerPage: 10,
            filters: [
                {
                    type: "options",
                    title: "Status",
                    field: "StatusName",
                    options: [
                        { text: "Aprovada", value: "Aprovada" },
                        { text: "Reprovada", value: "Reprovada" },
                        { text: "Pendente", value: "Pendente" },
                    ],
                    value: [],
                },
            ],
        };
    },
    mounted() {
        this.list();
    },
    computed: {
        ...mapGetters("generic", ["event"]),
    },
    methods: {
        ...mapMutations("generic", ["removeLoading"]),
        async list() {
            this.loading = true;
            try {
                const params = {
                    CurrentPage: this.currentPage,
                    TotalPerPage: this.totalPerPage,
                    Search: this.search || undefined,
                    Filter: this.search ? this.filter : undefined,
                    StringFilter: this.stringFilter || undefined,
                };
                const content = await AutorizationService.list(params);
                this.items = content.content.items || [];
                this.totalRecords = content.content.totalRecords || 0;
            } catch (e) {
                this.items = [];
                this.totalRecords = 0;
            } finally {
                this.loading = false;
                this.removeLoading(["panel", "loadingLine", "btnSearch", "btnClean"]);
            }
        },
        async setPageAndReload(page) {
            this.currentPage = page;
            return this.list();
        },
        async setTotalPerPageAndReload(totalPerPage) {
            this.totalPerPage = totalPerPage;
            this.currentPage = 1;
            return this.list();
        },
        async setSearchAndReload({ search, filter }) {
            this.search = search || "";
            this.filter = filter || "contains";
            this.currentPage = 1;
            return this.list();
        },
        async clearSearchAndReload() {
            return this.setSearchAndReload({ search: "", filter: "contains" });
        },
        onFilterQueryChange(filterQueryModel) {
            this.stringFilterModel = filterQueryModel;
            this.stringFilter = filterQueryModel ? JSON.stringify(filterQueryModel) : "";
            this.currentPage = 1;
            this.list();
        },
    },
    watch: {
        event: {
            handler(event) {
                if (event.name === "tagFilterRemove") {
                    this.setPageAndReload(1);
                }
                if (event.name === "stringFilter") {
                    this.stringFilter = event.data ? JSON.stringify(event.data) : "";
                    this.currentPage = 1;
                    this.list();
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.autorization-main-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 16px;
    padding: 18px 0 0 0;
}

.autorization-main-filter > :last-child {
    flex-shrink: 0;
}
</style>
